import { TasksState } from "./types";

export function getDefaultState(): TasksState {
    return {
        Tasks: [],
        TaskTypes: [],
        TaskCategories: [],
        TaskLibrary: [],
        ActionPlans: [],
        OutstandingRequiredTasks: [],
        ToggleActionListModal: false,
        NotificationServers: [],
        EditTriggerAction: null,
        CallContacts: null,
        DynamicDataList: [],
        DynamicData: [],
		ScriptCategoryLinks: []
    }
}
